import axios from 'axios';
import _ from 'lodash';
import * as types from '../constants/ActionTypes';

function requestCommunityResults() {
  return {
    type: types.REQUEST_COMMUNITY_RESULTS,
  };
}


function receiveCommunityResults(response) {
  const results = _.get(response, 'communtiyResults');
  return {
    type: types.RECEIVE_COMMUNITY_RESULTS,
    payload: {
      results,
    },
  };
}
function receiveCommunityResultsError() {
  return {
    type: types.RECEIVE_COMMUNITY_ERROR,
  };
}

export default function getCommunityResults(query) {
  return (dispatch) => {
    dispatch(requestCommunityResults());
    return axios.get(`/smarthelp/search-community?q=${query}`)
      .then(response => dispatch(receiveCommunityResults(response.data)))
      .catch(() => {
        dispatch(receiveCommunityResultsError());
      });
  };
}



// WEBPACK FOOTER //
// ./home/actions/action-community-posts.js